const styles = theme => ({
  buttonsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  button: {
    [theme.breakpoints.up('sm')]: {
      padding: '12px 50px',
      fontSize: 16,
    },
    textTransform: 'none',
    fontFamily: 'Roboto-Bold'
  },
  buttonCancel: {
    color: theme.palette.primary.main,
    marginRight: 10
  },
  messageContent: {
    '& .no-margin': {
      margin: 0
    }
  }
});

export default styles;